<template>
	<div style="width: 100%;background: #fff;height: 600px;" class="d-flex m-2">
		<div style="width: 100%;" class="m-1">
			<div style="font-weight: 800;">库存保质期统计</div>
			<div ref="myCharta" style="width: 100%; height: 580px;"></div>
		</div>
	</div>
</template>

<script>
import * as vueEcharts from 'echarts';
import moment from 'moment';
let echarts = require('echarts');
export default {
	data() {
		return {
			myChart: null,
			moment,
			day:[],
			kcsl:[],
			rksl:[],
			cksl:[]
		};
	},
	mounted() {
		// 画统计图
		this.changeRecent();
		this.drawLine();
		
	},
	created() {

		
		this.axios.get('/admin/kclss', { token: true }).then(res => {
			let list = res.data.data;
			var kclss = []
			var rklss = []
			var cklss = []
			for( let i = 0; i < 60; i++){
				let data = list.filter(item => item.create_time.slice(5,10) == this.day[i]) // 过滤filter()
				
				if(data.length == 0){
					kclss.push(0);
					rklss.push(0);
					cklss.push(0);
				}else{
					let tjsl = data.map(i => {
						let kcsl = 0;
						return (kcsl = kcsl + i.rksl + i.cksl);
					});
					tjsl = tjsl.reduce((a, b) => a + b); // 求和reduce()
					kclss.push(tjsl);
					
					let tjsla = data.map(i => {
						let kcsl = 0;
						return (kcsl = kcsl + i.rksl);
					});
					tjsla = tjsla.reduce((a, b) => a + b); // 求和reduce()
					rklss.push(tjsla);
					
					let tjslb = data.map(i => {
						let kcsl = 0;
						return (kcsl = kcsl + i.cksl);
					});
					tjslb = tjslb.reduce((a, b) => a + b); // 求和reduce()
					cklss.push(tjslb);
				}
			}
			this.kcsl = kclss
			this.rksl = rklss
			this.cksl = cklss
		});
	},
	methods: {
		changeRecent(value) {
			for(let i = 0;i<60;i++){
				this.day.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
			}
		},
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					tooltip: {
					    trigger: 'axis'
					  },
					  legend: {
					    data: ['当日流量', '入库', '出库']
					  },
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  toolbox: {
					    feature: {
					      saveAsImage: {}
					    }
					  },
					  xAxis: {
					    type: 'category',
					    boundaryGap: false,
					    data: that.day
					  },
					  yAxis: {
					    type: 'value'
					  },
					  series: [
					    {
					      name: '当日流量',
					      type: 'line',
					      data: that.kcsl
					    },
					    {
					      name: '入库',
					      type: 'line',
					      data: that.rksl
					    },
					    {
					      name: '出库',
					      type: 'line',
					      data: that.cksl
					    }
					  ]
				});
			}, 1000);
		}
	}
};
</script>

<style></style>
